<template>
    <div v-if="loaded===true" class="row">
        <div class="col-12 col-md-4 col-lg-3">
            <table class="table table-sm">
                <tr>
                    <td>{{ $t('order.order_number') }}</td>
                    <td>{{ order.order_number }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.address') }}</td>
                    <td>{{ order.address }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.date_ordered') }}</td>
                    <td>{{ order.ts }}</td>
                </tr>
                <tr>
                   <td>{{ $t('order.estimated_delivery') }}</td>
                    <td>{{ order.eta_delivery }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.price_with_tax') }}</td>
                    <td>{{ order.price_with_tax }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.note') }}</td>
                    <td>{{ order.note }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.status') }}</td>
                    <td>{{ order.status }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.sum_weight') }}</td>
                    <td>{{ order.sum_weight }}</td>
                </tr>
            </table>
        </div>
        <div class="col-12 col-md-8 col-lg-9">
            <order-product-row v-for="(product,index) in order.products" :key="index" :product="product"></order-product-row>
        </div>
        <div class="col-12 col-md-8 col-lg-9 mt-5" v-if="vatList.includes(order.vat) && paypalButton === true">
            <a v-bind:href="'/paypal-payment/' + order.order_number"><button class="btn btn-lg btn-primary">{{ $t('order.paypal') }}</button></a>
            <button class="btn btn-lg btn-primary">{{ $t('order.card') }}</button>
            <button class="btn btn-lg btn-primary">{{ $t('order.delivery') }}</button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loaded: false,
            paypalButton: false,
            vatList: ['SI00', 'SI01', '22704035', '93109310', '00254']
        }
    },
    props: {
        orderNumber: '',
        order: {
            type: Object,
            default: () => { return {nope: true}; },
        }
    },
    methods: {
        // TODO: Load order inside component, adds maintainability
        fetchOrder: function(id){
            this.loaded=false;
            axios.get('/dashboard/orders/' + id)
                .then(response => {
                    console.log(response);
                    this.order = response.data;
                    this.loaded = true;
                });
        }
    },
    created() {
        if (this.order.nope == true) {
            console.log(this.orderNumber);
            if(this.orderNumber != '' && typeof this.orderNumber != 'undefined') {
                this.fetchOrder(this.orderNumber);
            } else {
                this.paypalButton = true;
                this.fetchOrder(this.$store.getters.orderNumber);
            }
            this.$store.dispatch('setOrderNum', 0);
        } else {
            this.loaded=true;
        }
    },
}
</script>
<style>
</style>
